import { render, staticRenderFns } from "./item-show.vue?vue&type=template&id=b2ff652c&"
import script from "./item-show.vue?vue&type=script&lang=js&"
export * from "./item-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports